/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';

import { useParams } from '@thd-olt-component-react/router';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  Col,
  Row,
  Overlay,
  Image,
  Heading,
  Paper,
  Card,
  CardContent,
  CardFootnote,
  CardTitle
} from '@thd-olt-component-react/core-ui';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

import DenyClearVerificationApiProvider from '../context/DenyClearVerificationApiContext';
import { ClearPartnerWrapper } from '../components/clear/ClearPartnerWrapper';
import { ClearLandingBody } from '../components/clear/ClearLandingBody';

import '../styles/pages/ClearVerification.scss';

export const ClearVerification = () => {
  const [opened, setOpened] = useState(false);
  const { clearState = 'test-state-value' } = useParams();

  useEffect(() => {
    if (clearState) {
      setOpened(true);
    }
  }, []);

  return (
    <QueryProvider
      cacheKey="rental-clear-verification"
    >
      <Row className="isBound">
        <ErrorBoundary name="breadcrumbs">
          <Col>
            <div className="breadcrumbs" style={{ display: 'flex', flexWrap: 'nowrap' }}>
              <a href="//www.homedepot.com/" className="link">Home</a><div className="breadcrumbs-spacer">/</div>
              <a href="//www.homedepot.com/c/tool_and_truck_rental" className="link">
                Tool Rental
              </a><div className="breadcrumbs-spacer">/</div>
              <a href="#" className="link">Clear Verification</a>
            </div>
          </Col>
        </ErrorBoundary>
        <ErrorBoundary name="zone-a">
          <Col>
            <div className="desktop-spacer" />
            <Overlay
              open
              onClose={() => {}}
              medium
            >
              {
                clearState ? (
                  <DenyClearVerificationApiProvider state={clearState}>
                    <ClearPartnerWrapper>
                      <ClearLandingBody clearState={clearState} />
                    </ClearPartnerWrapper>
                  </DenyClearVerificationApiProvider>
                ) : (
                  <>
                    <Heading title="Clear Verification" underline centered />
                    <div
                      style={
                        {
                          display: 'flex',
                          justifyContent: 'center',
                          padding: '30px'
                        }
                      }
                    >
                      <div
                        style={
                          {
                            display: 'flex',
                            flexDirection: 'column',
                            maxHeight: '450px',
                            maxWidth: '450px'
                          }
                        }
                      >
                        <Image
                          stretchy
                          asset="bigtruck.svg"
                          alt="bigtruck"
                          title="bigtruck"
                          className="animated-truck"
                        />
                        <div className="shadow" />
                      </div>
                    </div>
                    <Heading title="This feature is coming soon." centered />
                  </>
                )
              }
            </Overlay>
          </Col>
        </ErrorBoundary>
      </Row>
    </QueryProvider>
  );
};

ClearVerification.displayName = 'ClearVerificationPage';
ClearVerification.propTypes = {};
ClearVerification.defaultProps = {};
